import { render, staticRenderFns } from "./Paneles.vue?vue&type=template&id=20771d31"
import script from "./Paneles.vue?vue&type=script&lang=js"
export * from "./Paneles.vue?vue&type=script&lang=js"
import style0 from "./Paneles.vue?vue&type=style&index=0&id=20771d31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports